import React from "react";
import { useFormik } from "formik";
import { newCOCStep1Schema } from "../../utils/schemas";
import { Box, Button, HStack, SimpleGrid, Stack } from "@chakra-ui/react";
import { CInput } from "../common";
import ExternalOrderImportPanel from "./ExternalOrderImportPanel";

/**
 * @param {'manual' | 'external'} props.clientSource — from parent when fetch integrations exist
 * @param {Array} [props.integrations] — fetch_order_by_id rows (for external panel)
 */
export default function NewCOCStep1({
  onNextStep,
  onBackStep,
  formData,
  user,
  onApplyImport,
  clientSource = "manual",
  integrations = [],
}) {
  const formik = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema: newCOCStep1Schema,
    onSubmit: (values) => onNextStep(values),
  });

  const phoneNumberAutoFormat = (phoneNumber) => {
    const input = phoneNumber.replace(/\D/g, "");
    return input.substring(0, 11);
  };

  const showImportPanel =
    Boolean(onApplyImport) &&
    clientSource === "external" &&
    integrations.length > 0;

  return (
    <>
      {showImportPanel ? (
        <ExternalOrderImportPanel
          integrations={integrations}
          formData={formik.values}
          onImported={(merged) => {
            onApplyImport(merged);
            formik.resetForm({ values: merged });
          }}
        />
      ) : null}

      {user?.role === "user" ? (
        <Box mb={4}>
          <CInput
            label="Reference ID"
            name="refId"
            placeholder="External integration order id (optional)"
            value={formik.values.refId ?? ""}
            onChange={(e) =>
              formik.setFieldValue("refId", e.target.value)
            }
            errors={formik.errors.refId}
            touched={formik.touched.refId}
          />
        </Box>
      ) : null}

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={3} mb="4">
        <CInput
          label="Company Name"
          name="clientName"
          placeholder="Enter Name"
          value={formik.values.clientName}
          onChange={formik.handleChange}
          errors={formik.errors.clientName}
          touched={formik.touched.clientName}
        />
        <CInput
          label="Contact Name"
          name="contactName"
          placeholder="Enter Contact Name"
          value={formik.values.contactName}
          onChange={formik.handleChange}
          errors={formik.errors.contactName}
          touched={formik.touched.contactName}
          isRequired
        />
        <CInput
          label="Client Email"
          name="email"
          placeholder="Enter Email"
          value={formik.values.email}
          onChange={formik.handleChange}
          errors={formik.errors.email}
          touched={formik.touched.email}
          isRequired
        />
        <Stack>
          <CInput
            label="Phone"
            name="phone"
            placeholder="Enter Phone (xxxxxxxxxxx)"
            value={formik.values.phone}
            onChange={(e) => {
              let temp = phoneNumberAutoFormat(e.target.value);
              formik.setFieldValue("phone", temp);
            }}
            errors={formik.errors.phone}
            touched={formik.touched.phone}
            isRequired
          />
        </Stack>
      </SimpleGrid>
      <HStack justifyContent="end">
        {user?.role === "admin" && (
          <Button
            type="button"
            onClick={() => onBackStep(formik.values)}
            isLoading={formik.isSubmitting}
            loadingText="Loading..."
            bgColor="black"
            borderRadius="lg"
            fontWeight="medium"
            py="6"
            px="7"
          >
            Back
          </Button>
        )}
        <Button
          type="submit"
          onClick={formik.handleSubmit}
          isLoading={formik.isSubmitting}
          loadingText="Loading..."
          bgColor="black"
          borderRadius="lg"
          fontWeight="medium"
          py="6"
          px="7"
        >
          Next
        </Button>
      </HStack>
    </>
  );
}
